import * as React from "react";
const baseClass = "rj-message";
export var MessageStates;
(function (MessageStates) {
    MessageStates["info"] = "rj-message--info";
    MessageStates["error"] = "rj-message--error";
    MessageStates["warning"] = "rj-message--warning";
})(MessageStates || (MessageStates = {}));
export class Message extends React.Component {
    render() {
        let cls = `${baseClass} ${this.props.type || MessageStates.info}`;
        /* istanbul ignore next */
        return (React.createElement("div", { className: cls }, this.props.text || this.props.children));
    }
}
//# sourceMappingURL=Message.js.map